<script setup lang="ts">
import DecorIcon from "#ui/primitives/decorIcon/DecorIcon.vue";
import type { CartBoxIconControl } from "../cartBoxControls";

defineProps<{ control: CartBoxIconControl }>();
</script>

<template>
	<DecorIcon :icon="control.icon" :fallback="control.fallback" />
</template>
